/* New York Blog — responsive hero video (New York-specific). Bottom gallery uses native scroll/grid. */
/* Mirrors assets/corsica-blog.js on JS - Staging. Hook: [data-ny-hero]. */
(function () {
  function initNewYork(root) {
    if (!root || root.dataset.nyInit === '1') return;
    root.dataset.nyInit = '1';

    var hero = root.querySelector('[data-ny-hero]');
    if (hero) {
      var video = hero.querySelector('.new-york-blog__hero-video');
      var mq = window.matchMedia('(max-width: 768px)');
      var currentMode = null;

      var applySource = function () {
        var isMobile = mq.matches;
        var mode = isMobile ? 'mobile' : 'desktop';
        if (mode === currentMode) return;
        currentMode = mode;
        hero.setAttribute('data-mode', mode);
        if (!video) return;

        var w = window.innerWidth || document.documentElement.clientWidth;
        var src;
        if (isMobile) {
          src = hero.getAttribute('data-mobile-src-sd') || hero.getAttribute('data-mobile-src');
        } else {
          src = (w >= 769) ? hero.getAttribute('data-desktop-src') : hero.getAttribute('data-desktop-src-sd');
        }
        if (!src) return;

        video.setAttribute('muted', '');
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.src = src;
        try { video.load(); } catch (e) {}
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      };

      applySource();
      if (mq.addEventListener) { mq.addEventListener('change', applySource); }
      else if (mq.addListener) { mq.addListener(applySource); }
    }
    /* Bottom gallery uses native horizontal scroll / CSS grid — no JS controls. */
  }

  function boot() {
    var nodes = document.querySelectorAll('.new-york-blog');
    for (var i = 0; i < nodes.length; i++) { initNewYork(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
